import { AdNiche, adNicheBySlug } from "../../pages/AdSignup/niches";

const key = "Keepo.adIntent";

export const AD_INTENT_TTL_MS = 60 * 60 * 1000;

// Guarda de qual página de anúncio a pessoa veio (slug null = genérica), por 1 hora.
export function saveAdIntent(slug: string | null, now: number = Date.now()): void {
  try {
    localStorage.setItem(key, JSON.stringify({ slug, at: now }));
  } catch (e) {
    // sem localStorage, segue sem a intenção
  }
}

export function readAdIntent(now: number = Date.now()): AdNiche | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const stored = JSON.parse(raw);
    const validSlug = typeof stored?.slug === "string" || stored?.slug === null;
    if (!validSlug || typeof stored.at !== "number") return null;
    // an `at` in the future (a wrong clock, a tampered value) isn't valid either: 0 <= age <= 1 hour
    const age = now - stored.at;
    if (age < 0 || age > AD_INTENT_TTL_MS) return null;
    return adNicheBySlug(stored.slug);
  } catch (e) {
    return null;
  }
}

export function clearAdIntent(): void {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // sem localStorage, nada a apagar
  }
}
